export default function CsharpOptionalParameters() {
  return (
    <h2>Csharp Optional Parameters</h2>
  );
}
